import { appClient } from 'api/apiClient';
import type { StripeOnboardingLink, StripeParishStatus } from 'types/stripe';

/** GET /v1/parishes/:parishId/stripe/status — CLERK+. */
export async function fetchStripeStatus(parishId: string): Promise<StripeParishStatus> {
    const res = await appClient.get<StripeParishStatus>(`parishes/${parishId}/stripe/status`);
    return {
        connected: Boolean(res?.connected),
        chargesEnabled: Boolean(res?.chargesEnabled),
        onboardedAt: res?.onboardedAt ?? null,
    };
}

/** POST /v1/parishes/:parishId/stripe/onboarding-link — MERCHANT_ADMIN+. Empty body. */
export async function createStripeOnboardingLink(parishId: string): Promise<StripeOnboardingLink> {
    const res = await appClient.post<StripeOnboardingLink>(`parishes/${parishId}/stripe/onboarding-link`, {});
    return {
        url: String(res?.url || ''),
        expiresAt: String(res?.expiresAt || ''),
    };
}
